
export const environment = {
  production: false,
  googleAuthClientId: '585162258210-a9etmmp31sp0dm53bch829ooqoil7o12.apps.googleusercontent.com',
  urlServerAuth: 'https://bff-pdg-light-dev.zentagroup.com/api/v1/znt-pgd-auth/',
  urlServerErp: 'https://bff-pdg-light-dev.zentagroup.com/api/v1/znt-pgd-erp/',
  urlServerProject: 'https://bff-pdg-light-dev.zentagroup.com/api/v1/znt-pdg-project/',
  urlServerTaas: 'https://bff-pdg-light-dev.zentagroup.com/api/v1/znt-pdg-taas/',
  urlServerService: 'https://bff-pdg-light-dev.zentagroup.com/api/v1/znt-pdg-service/',
  urlServerEjecutive: 'https://bff-pdg-light-dev.zentagroup.com/api/v1/znt-pdg-payment/',
  urlServerApi: 'https://bff-pdg-light-dev.zentagroup.com/api/v1/znt-pgd-api/',

};

